import isNil from 'lodash/isNil';
import React, {
  useState,
} from 'react';
import MaskedTextField from 'core/components/MaskedTextField';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  TextFieldProps,
} from '@mui/material/TextField';
import ToolTip from 'core/components/Tooltip';
import IconButton from '@mui/material/IconButton';

const commonSSNMask = {
  definitions: {
    X: {
      mask: '0',
      displayChar: 'X',
    },
  },
  overwrite: true,
  eager: true,
};

const securedSSNMask = [{
  ...commonSSNMask,
  mask: 'XXX-XX-XX00',
}];
const unSecuredSSNMask = [{
  ...commonSSNMask,
  mask: '000-00-0000',
}];

type Props = {
  value: string;
  onChange: (value: string) => void;
} & TextFieldProps;

export default function SSNInput({
  value,
  onChange,
  ...props
}: Props) {
  const [securedSSN, setSecuredSSN] = useState<boolean>(true);
  const Icon = securedSSN ? VisibilityIcon : VisibilityOffIcon;

  return (
    <>
      <MaskedTextField
        {...props}
        unmask
        mask={securedSSN ? securedSSNMask : unSecuredSSNMask}
        value={value}
        onAccept={(_value: string) => {
          onChange(_value);
        }}
        inputProps={{ autoComplete: 'off' }}
        placeholder="SSN e.g 000-11-5555"
        className="populate-input populate-number-input bg-white"
      />
      {!isNil(value) && (
      <ToolTip
        title={securedSSN ? 'Show SSN' : 'Hide SSN'}
        aria-label="Show SSN"
      >
        <span>
          <IconButton
            color="info"
            size="small"
            onClick={() => { setSecuredSSN(!securedSSN); }}
          >
            <Icon className="!w-5 !h-5 !text-gray-500 mt-0.5" />
          </IconButton>
        </span>
      </ToolTip>
      )}
    </>
  );
}
